import React from 'react';

// Vertical eval bar. White's share of the bar grows as the eval goes up.
// Uses the same cp → win% curve lichess uses.
export default function EvalBar({ evaluation, status }) {
  let whitePct = 50;
  let label = '…';

  if (evaluation) {
    if (evaluation.mate !== null) {
      whitePct = evaluation.mate > 0 ? 98 : 2;
      label = `M${Math.abs(evaluation.mate)}`;
    } else {
      const winChance = 2 / (1 + Math.exp(-0.00368208 * evaluation.cp)) - 1;
      whitePct = 50 + 50 * winChance;
      whitePct = Math.max(3, Math.min(97, whitePct));
      label = (evaluation.cp >= 0 ? '+' : '') + (evaluation.cp / 100).toFixed(1);
    }
  } else if (status === 'loading') {
    label = '…';
  } else if (status === 'error') {
    label = '!';
  }

  return (
    <div className="vc-evalbar" title={`Engine eval: ${label}`}>
      <div className="vc-evalbar-black" style={{ height: `${100 - whitePct}%` }} />
      <div className="vc-evalbar-white" style={{ height: `${whitePct}%` }} />
      <span className={`vc-evalbar-label ${whitePct >= 50 ? 'on-white' : 'on-black'}`}>
        {label}
      </span>
    </div>
  );
}
